import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=565563ce&scoped=true"
import script from "./ProductInformation.vue?vue&type=script&lang=js"
export * from "./ProductInformation.vue?vue&type=script&lang=js"
import style0 from "./ProductInformation.vue?vue&type=style&index=0&id=565563ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565563ce",
  null
  
)

export default component.exports